import { render } from "./SentInvitations.vue?vue&type=template&id=1b1b7270&scoped=true"
import script from "./SentInvitations.vue?vue&type=script&lang=js"
export * from "./SentInvitations.vue?vue&type=script&lang=js"

import "./SentInvitations.vue?vue&type=style&index=0&id=1b1b7270&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b1b7270"]])

export default __exports__